import { Summary } from '../models/summary.interfaces';

export const SummaryNoMilesMocks: Summary = {
  header: 'SkyMiles Overview',
  label: '0',
  title: 'MILES AVAILABLE',
  description: 'Use these miles for Award Travel and other redemptions.',
  action: {
    id: 'skyMilesOverviewBookFlight',
    label: 'BOOK A FLIGHT',
    link: '/flight-search/book-a-flight'
  },
  disabled: false,
  loaded: true
};
